import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import { ButtonV2, Link } from '@zola/zola-ui';

import './RegistryAndWebsiteShareModal.less';

const CopyUrl = ({ product, url, id }) => {
  let clipboard;
  let clipboardTimer;
  const [copyCTA, setCopyCTA] = useState('Copy URL');
  const [copyLinkDisabled, setCopyLinkDisabled] = useState(false);

  useEffect(() => {
    clipboard = new Clipboard(`#${id}`);

    clipboard.on('success', () => {
      setCopyCTA('Copied!');
      setCopyLinkDisabled(true);

      clipboardTimer = setTimeout(() => {
        setCopyCTA('Copy URL');
        setCopyLinkDisabled(false);
      }, 1500);
    });

    return () => {
      if (clipboard) clipboard.destroy();
      if (clipboardTimer) clearTimeout(clipboardTimer);
    };
  }, []);

  return (
    <div className="registryAndWebsiteShareModal__copyUrl">
      <span className="registryAndWebsiteShareModal__label">{`Your ${product} URL`}</span>
      <div className="registryAndWebsiteShareModal__copyUrlBlock">
        <div className="registryAndWebsiteShareModal__url">{url}</div>
        <ButtonV2 id={id} onClick={() => {}} disabled={copyLinkDisabled} data-clipboard-text={url}>
          {copyCTA}
        </ButtonV2>
      </div>
      <Link
        href={`${url}?preview=true`}
        className="registryAndWebsiteShareModal__previewLink"
        target="_blank"
        rel="noreferrer noopener"
      >
        {`Preview ${product}`}{' '}
        <i className="zola-ui-icon-link-ext registryAndWebsiteShareModal__preview--icon" />
      </Link>
    </div>
  );
};

CopyUrl.propTypes = {
  product: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

const RegistryAndWebsiteShareModal = ({
  title,
  websiteIsPublic,
  registryIsPublic,
  websiteUrl,
  registryUrl,
}) => {
  const renderWebsiteUrl = () => {
    if (!websiteIsPublic)
      return (
        <div className="registryAndWebsiteShareModal__notVisible">
          <span className="semibold text-black">Want to share your website?</span> First make it visible to guests.
        </div>
      );

    return <CopyUrl url={websiteUrl} product="Website" id="copyWebsiteUrl" />;
  };

  const renderRegistryUrl = () => {
    if (!registryIsPublic)
      return (
        <div className="registryAndWebsiteShareModal__notVisible">
          <span className="semibold text-black">Want to share your registry?</span> First make it visible to guests.
        </div>
      );

    return <CopyUrl url={registryUrl} product="Registry" id="copyRegistryUrl" />;
  };

  return (
    <div>
      <div className="registryAndWebsiteShareModal__content">
        <h2 className="registryAndWebsiteShareModal__title text-center">{title}</h2>
        {renderRegistryUrl()}
        {renderWebsiteUrl()}
      </div>
      <div className="registryAndWebsiteShareModal__footer text-center">
        <span className="registryAndWebsiteShareModal__footer--label">
          Want to edit and manage your URLs?
        </span>
        <Link href="/account/settings/urls">View Settings</Link>
      </div>
    </div>
  );
};

RegistryAndWebsiteShareModal.propTypes = {
  title: PropTypes.string,
  websiteUrl: PropTypes.string,
  registryUrl: PropTypes.string,
  registryIsPublic: PropTypes.bool,
  websiteIsPublic: PropTypes.bool,
};

RegistryAndWebsiteShareModal.defaultProps = {
  websiteIsPublic: false,
  registryIsPublic: false,
};

export default RegistryAndWebsiteShareModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/RegistryAndWebsiteShareModal/RegistryAndWebsiteShareModal.jsx